// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"4bf33a8c","646":"f321c98b"}[chunkId] + ".chunk.js";
};